import React from "react";
import { connect } from "react-redux";
import { startForgetPass } from "../actions/auth";
import { Link } from "react-router-dom";
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Input } from "antd";
import Logo from "../assets/images/up-logo.svg";
import "../styles/components/login.scss";
import "../styles/components/button.scss";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: ""
    };
  }

  onChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState(() => ({ [name]: value }));
  };

  onSubmit = e => {
    e.preventDefault();
    this.props.startForgetPass(this.state.user);
  };

  render() {
    return (
      <div className="box-layout__box">
        <img src={Logo} alt="logo" />
        <div className="box-layout__box__container">
          <div className="box-layout__box__header">
            <h2>Forgot your password?</h2>
            <p>We’ll help you reset it and get back on track.</p>
          </div>
          <Form className="box-layout__form" onSubmit={this.onSubmit}>
            <div className="form-input">
              <label>Email address</label>
              <Input
                type="email"
                name="user"
                autoFocus
                placeholder="Email address"
                value={this.state.user}
                onChange={this.onChange}
                size="large"
              />
            </div>
            <div className="box-layout__other">
              <div className="login-button-container">
                <Button
                  className="button-login"
                  type="primary"
                  shape="round"
                  size="large"
                  loading={this.props.fetchInProgress}
                  htmlType="submit"
                >
                  Reset Password
                </Button>
              </div>
            </div>
          </Form>
        </div>
        <div className="fancy-detour">
          <p>Already have an account?</p>
          <Link to="/login" className="button-guest">
            Login
          </Link>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetchInProgress: state.fetchInProgress
});

const mapDispatchToProps = dispatch => ({
  startForgetPass: email => dispatch(startForgetPass(email))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginPage);
